<div class="content-container">
    <nav class="menu-nav">
        <a mat-button (click)="onSignOut()">Sign out</a>
    </nav>
    <div class="logo">
        <div id="logo-placeholder"></div>
    </div>
    <header>
        <h2>Select your account</h2>
    </header>
    <div class="content">
        <div class="errors message-box message--warning" style="margin: 0 auto 20px;" *ngIf="authFailText">
            <p [innerHTML]="authFailText"></p>
        </div>
        <div>
            <div *ngFor="let user of users" class="account-btn">
                <div title="{{user.managerId}} - {{user.managerName}}" (click)="selectUser(user.userId)">
                    <span [innerHTML]="user.managerName"></span>
                    <img id="logo-{{user.managerId}}" [alt]="user.managerName" src="https://static.adminis.co.nz/images/myadminis/logos/{{user.managerId}}.svg" (error)="$event.srcElement.remove()" />
                </div>
            </div>
        </div>
        <br />
        <p *ngIf="contactUsLink">Having trouble logging in? <a [href]="contactUsLink" target="_blank">Contact us</a></p>
    </div>
</div>
<app-spinner *ngIf="showSpinner" class="fullscreen-spinner"></app-spinner>